export function getDuration(startDate, stopDate) {
  let durationInMilliseconds = new Date(stopDate) - new Date(startDate);
  let minutes = Math.floor(durationInMilliseconds / 60000);
  let seconds = ((durationInMilliseconds % 60000) / 1000).toFixed(0);
  return seconds == 60
    ? minutes + 1 + 'min 00 sec'
    : minutes + ' min ' + (seconds < 10 ? '0' : '') + seconds + ' sec';
}
